import isNotBetween  from './isNotBetween';

export default function isBetween(minDate: any, maxDate: any, selectedDay: any){
    return !isNotBetween(minDate, maxDate, selectedDay)
}
